import ElectricEnergySuppliers from "../classes/ElectricEnergySupplier";
import { Position } from 'reactflow';

export const electricEnergySuppliers = [
  new ElectricEnergySuppliers({
    alias:"utility-b", 
    svgSrc: "/symbol-assets/UtilitySimbolo2.svg", 
    label: "Proveedor eléctrico",
    rotable: true,
    handles: [
      {
        type: "source",
        position: Position.Bottom
      }      
    ]
  }),

  new ElectricEnergySuppliers({
    alias:"utility-a", 
    svgSrc: "/symbol-assets/UtilitySimbolo1.svg", 
    label: "Proveedor eléctrico",
    rotable: true,
    handles: [
      {
        type: "source",
        position: Position.Bottom
      }      
    ]
  }),

  
  new ElectricEnergySuppliers({
    alias:"generador-a", 
    svgSrc: "/symbol-assets/GeneradorSimbolo1.svg", 
    label: "Generador",
    rotable: true,
    handles: [
      {
        type: "source",
        position: Position.Bottom
      }      
    ]
  }),

  new ElectricEnergySuppliers({
    alias:"banco-baterias", 
    svgSrc: "/symbol-assets/BancoDeBaterias.svg", 
    label: "Banco de baterías",
    rotable: true,
    handles: [
      {
        type: "source",
        position: Position.Bottom
      }      
    ]
  }),
  new ElectricEnergySuppliers({
    alias:"generador-solar", 
    svgSrc: "/symbol-assets/GeneradorSolar.svg", 
    label: "Generador fotovoltaico",
    rotable: true,
    handles: [
      {
        type: "source",
        position: Position.Bottom
      }      
    ]
  }),
  new ElectricEnergySuppliers({
    alias:"generador-eolico", 
    svgSrc: "/symbol-assets/GeneradorEolico.svg", 
    label: "Aerogenerador",
    rotable: true,
    handles: [
      {
        type: "source",
        position: Position.Bottom
      }      
    ]
  }),
];
